export default "__VITE_ASSET__D78f7S____"